import styled from 'theme';

import { VZButton as VZButtonComponent } from './VZButton';

export const VZButton = styled(VZButtonComponent)`
  min-width: 9.375rem;
`;
